<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <vue-plotly :white-mode="whiteMode" disable-responsive v-if="!loading&&!error&&data1" :data="data1" :layout="layout1" ref="feplot"
                    :options="{}"/>
        <v-alert v-if="!loading&&error"
                 :value="error"
                 type="error"
        >
            {{error}}
        </v-alert>
        <data3-chart v-if="!loading&&!error" v-for="(unitVars,unitName) in variableList" :key="'rv'+unitName"
                     :layout-overrides="{shapes:shapes,title:relvtitle,height:300,margin:layoutOverrides.margin,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                     :on-only="false"
                     :x-axis="'timestamp'"
                     disable-responsive
                     :show-export="false"
                     :white-mode="whiteMode"
                     ref="rvplots"
                     just-plot
                     :data-payload="unitVars"
                     :date-range="dateRange"></data3-chart>
        <vue-plotly v-if="!loading&&!error&&showCost" disable-responsive :data="costData" :layout="costLayout" :options="{}"/>
    </div>
</template>

<script>
    import {runRuleTest, getParameter, getPoint} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from 'moment'
    import Data3Chart from "./../Data3Chart";

    export default {
        props: {
            dateRange: {type: Object, default: null},
            equipmentName: {type: String, default: null},
            relevantVariables: {type: String, default: null},
            rule: {type: String, default: null},
            value: {type: String, default: null},
            cost: {type: String, default: "0"},
            title: {type: String, default: null},
            onOnly: {type: Boolean, default: false},
            showCost: {type: Boolean, default: false},
            whiteMode:{type:Boolean, default: false},
        },
        components: {LoadingProgressBar, VuePlotly, Data3Chart},
        computed: {},
        name: 'FaultEvalWidget',
        watch: {
            dateRange() {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout: null,
                layout1: null,
                data1: null,
                error: null,
                shapes: [],
                layout: null,
                variableList: [],
                layoutOverrides: {},
                nOct: null,
                costData: null,
                nOcDuration: null,
                costLayout:{
                    title:this.$options.filters.translate('Cost'),
                    yaxis: {
                        title: 'kWh',
                        rangemode: 'tozero'
                    },
                    xaxis: {
                        title: ""

                    },
                    legend: {
                        orientation: 'h',
                        traceorder:'normal',
                        y:-0.3
                    },
                    showlegend:true,
                    hovermode:"x",
                    hoverlabel: {
                        namelength: -1,
                    },
                    height:300,
                    margin: {
                        t: 30,
                        b: 30
                    },
                },
                relvtitle: this.$options.filters.translate('Relevant variables'),
            }
        },

        async mounted() {
            let df1 = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.parameter = df1['result']
            let df = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment_name: this.equipmentName
            })
            this.points = df['result']
            this.refresh()
        },
        methods: {
            getUnit(varName) {
                for (let point of this.points) {
                    if (point.sensor_name === varName && point.equipment_name === this.equipmentName) {
                        if (point.unit) {
                            return point.unit
                        }
                        break
                    }
                }
                if (varName.toLowerCase().includes("tem")) {
                    return "°C"
                } else if (varName.toLowerCase().includes("press")) {
                    return "kPa"
                } else if (varName.toLowerCase().includes("status")) {
                    return "status"
                } else if (varName.toLowerCase().includes("_hr")) {
                    return "hour"
                }
                return "";
            },
            getVarDetails(varName) {
                for (let point of this.points) {
                    if (point.sensor_name === varName && point.equipment_name === this.equipmentName) {
                        return point
                    }
                }
                return {}
            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => callback(), wait);
            },
            refresh() {
                this.debounce(this.getData, 500);
            },
            getData() {
                let me = this
                me.loading = true
                me.error = null
                if (this.equipmentName && this.equipmentName !== "" && this.rule && this.rule !== "") {
                    runRuleTest({
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'rule': this.rule,
                        'on': this.onOnly,
                        'value': this.value,
                        'cost': this.cost,
                        'equipment_name': this.equipmentName,
                        'date_range': this.dateRange ? [this.dateRange.start, this.dateRange.end + " 23:59:59"] : null
                    }).then(function (response) {
                        if (response.error) {
                            me.error = response.error
                            me.loading = false
                        } else {
                            let prefiller = null
                            if (me.rule.match(/rolling\((.*?)\)/g)) {
                                try {
                                    let matchedset = me.rule.match(/rolling\((.*?)\)/g)
                                    let roller = matchedset[matchedset.length - 1].match(/rolling\((.*?)\)/)[1]
                                    if (roller.indexOf("config[") > -1 && me.parameter) {
                                        for (let parameter of me.parameter) {
                                            roller = roller.replace("config['" + parameter.parameter_name + "']", parameter.parameter_value)
                                        }
                                    }
                                    prefiller = eval(roller)
                                } catch (e) {
                                    prefiller = null
                                }
                            }
                            let timestamp = response.timestamp
                            let ruleTest = response.evaluate
                            let refinedY = new Array(timestamp.length).fill(false);
                            for (let index in ruleTest) {
                                if (ruleTest[index]) {
                                    refinedY[index] = true
                                    if (prefiller) {
                                        let base = index
                                        for (let i = 1; i <= prefiller; i++) {
                                            if (timestamp[base - i]) {
                                                refinedY[base - i] = true
                                            }
                                        }
                                    }
                                }
                            }
                            let shape = null
                            let shapes = []
                            let mainShapes = []
                            for (let index in refinedY) {
                                if (refinedY[index] && index < refinedY.length - 1) {
                                    if (!shape) {
                                        shape = {
                                            x0: timestamp[index],
                                            x1: timestamp[index],
                                            yref: 'paper',
                                            y0: 0,
                                            type: "rect",
                                            octCount: 1,
                                            y1: 1,
                                            fillcolor: 'rgb(214, 39, 40)',
                                            opacity: 0.05,
                                            line: {
                                                width: 0
                                            }
                                        }
                                    } else {
                                        shape.x1 = timestamp[index]
                                        shape.octCount = shape.octCount + 1
                                    }
                                } else {
                                    if (shape) {
                                        if (shape.x0 == shape.x1) {
                                            shape.x1 = moment(shape.x1).add(me.$store.getters.minutesBetweenSamples, 'minute').format('YYYY-MM-DD HH:mm:ss')
                                        }
                                        shapes.push({...shape})
                                        shape.opacity = 1
                                        mainShapes.push(shape)
                                        shape = null
                                    }
                                }
                            }
                            me.shapes = shapes;
                            me.nOct = shapes.length
                            me.nOcDuration = shapes.reduce((sum, x) => sum + x.octCount, 0) / me.$store.state.pointsListStore.pointsList.sampling_freq / 24
                            me.data1 = [
                                {
                                    x: timestamp,
                                    y: refinedY,
                                    name: me.$options.filters.translate('Rule evaluation'),
                                    type: 'scatter',
                                    mode: 'none',
                                },
                            ]
                            me.layout1 = {
                                height: 90,
                                margin: {
                                    t: 30,
                                    b: 30
                                },
                                plot_bgcolor: 'rgb(31, 119, 180)',
                                title: me.title,
                                yaxis: {
                                    title: 'Rule',
                                    fixedrange: true,
                                    categoryorder: 'array',
                                    range: [0, 1],
                                    showticklabels: false,
                                    categoryarray: ["false", "true"],
                                    showgrid: false,
                                },
                                shapes: mainShapes,
                                xaxis: {
                                    title: '',
                                    showgrid: false,
                                },
                                hoverlabel: {bgcolor: "#606060"},
                            }
                            if (me.relevantVariables && me.relevantVariables !== "" && me.relevantVariables !== "0") {
                                let relVarList = {};
                                let relvars = me.relevantVariables.split(',').map(x=>x.trim())
                                for (let varName of relvars) {
                                    let unit = me.getUnit(varName)
                                    if (!relVarList[unit]) {
                                        relVarList[unit] = [];
                                    }
                                    let desc = me.getVarDetails(varName).sensor_desc
                                    let pad = desc ? " - " + desc : ""
                                    let unitpad = unit && unit !== "" ? " (" + unit + ")" : ""
                                    relVarList[unit].push({
                                        'filters': {
                                            equipment_name: me.equipmentName,
                                            sensor_name: varName,
                                            facility_name: me.$store.state.pointsListStore.pointsList.facility_name,
                                        },
                                        pipeline: [
                                            {
                                                type: "calculate",
                                                formula: 'df["' + me.equipmentName + ' - ' + varName + '"]',
                                                name: varName + pad + unitpad,
                                                "remove_others": true
                                            }
                                        ],
                                        seriesOverrides: {
                                            type: 'scatter',
                                            opacity: 1,
                                            xbins: {
                                                size: 1
                                            }
                                        },
                                    })
                                }
                                me.variableList = relVarList;
                            }
                            me.layoutOverrides = {
                                title: me.$options.filters.translate("Relevant variables"),
                                xaxis: {
                                    title: '',
                                },
                                yaxis: {
                                    fixedrange: true
                                },
                                margin: {
                                    t: 30,
                                    b: 0
                                },
                                height: 300,
                                showlegend: true,
                                legend: {
                                    orientation: 'h',
                                    y: -0.2,
                                },
                                hoverlabel: {
                                    namelength: -1
                                },
                                hovermode: "x",
                                shapes: [],
                            }
                            me.costData = [
                                {
                                    x: response.timestamp,
                                    y: response.cost,
                                    name: 'Cost (kWh)',
                                    type: 'scatter',
                                    mode: 'lines'
                                },
                            ]

                            me.loading = false

                        }
                    })
                }
            }
        },
    }
</script>

<style scoped>

</style>
